module.exports = __webpack_public_path__ + "img/patient-info-up.38479b0e.svg";